import { textFilter } from "react-bootstrap-table2-filter";
import { FieldParams } from "../../core/FieldObject";
import {
  DeepMergeObject,
  DotStringToObject,
  getCellStyle,
  GetHeaderStyle,
  GetNormalStyle,
  PostJson,
  toDecimal,
} from "../../core/Helper";
import { FieldDataType, FormControlType } from "../../core/Helper2";
import { BsCheck2 } from "react-icons/bs";
import styled from "styled-components";

export const DFRatioObj = (props) => {
  const { sourcePriceList, calcMethodList, onSelectSourcePrice } = props;

  return {
    DfRatioId: {
      ...new FieldParams(
        "DfRatioId",
        "",
        true,
        FieldDataType.NUMERIC,
        FormControlType.HIDDEN
      ),
      isHiddenColumn: true,
    },
    DfRatioCode: {
      ...new FieldParams("DfRatioCode", "รหัส", true),
      defaultHeaderStyle: GetHeaderStyle("120px"),
    },
    DfRatioName: { ...new FieldParams("DfRatioName", "ชื่อเรียก", true) },
    CalcuMethod: {
      ...new FieldParams(
        "CalcMethod",
        "วิธี",
        true,
        FieldDataType.NUMERIC,
        FormControlType.SELECT
      ),
      tableColumnFieldName: "CalcMethod.CalcMethodName",
      selectData: calcMethodList,
      selectHasFirstOption: false,
      selectValueName: "CalcMethodId",
      selectDisplayName: "CalcMethodName",
      defaultHeaderStyle: GetHeaderStyle("120px", "center"),
      defaultCellStyle: getCellStyle("center"),
    },
    CalcuValue: {
      ...new FieldParams(
        "CalcuValue",
        "อัตราปรกติ",
        true,
        FieldDataType.NUMERIC,
        FormControlType.DECIMAL_LOCK_VALUE
      ),
      defaultHeaderStyle: GetHeaderStyle("120px", "center"),
      defaultCellStyle: getCellStyle("right"),
      style: { ...{ width: "150px" } },
      formatter: (cell) => toDecimal(cell, 2),
    },
    // CalcuValueLately: {
    //   ...new FieldParams(
    //     "CalcuValueLately",
    //     "อัตราอ่านช้า",
    //     true,
    //     FieldDataType.NUMERIC,
    //     FormControlType.DECIMAL_LOCK_VALUE
    //   ),
    //   defaultHeaderStyle: GetHeaderStyle("120px", "center"),
    //   defaultCellStyle: getCellStyle("right"),
    //   style: { ...{ width: "150px" } },
    //   formatter: (cell) => toDecimal(cell, 2),
    // },
    SourcePrice: {
      ...new FieldParams(
        "SourcePrice",
        "คำนวณจาก",
        true,
        FieldDataType.NUMERIC,
        FormControlType.SELECT
      ),
      tableColumnFieldName: "SourcePrice.SourcePriceName",
      selectData: sourcePriceList,
      selectHasFirstOption: false,
      selectValueName: "SourcePriceId",
      selectDisplayName: "SourcePriceName",
      onChange: onSelectSourcePrice,
      defaultHeaderStyle: GetHeaderStyle("120px", "center"),
      defaultCellStyle: getCellStyle("center"),
    },
    // PerCaseFlag: {
    //   ...new FieldParams(
    //     "PerCaseFlag",
    //     "คำนวณเหมาต่อเคส",
    //     true,
    //     FieldDataType.BOOLEAN,
    //     FormControlType.CHECK_BOX
    //   ),
    //   style: {
    //     flex: "1",
    //     display: "flex",
    //     justifyContent: "start",
    //     paddingLeft: "200px",
    //     paddingTop: "10px",
    //   },
    //   formatter: (cell) => {
    //     return cell ? <BsCheck2 size={30} color="var(--icon-fore)" /> : <></>;
    //   },
    //   defaultHeaderStyle: GetHeaderStyle("50px", "center"),
    //   defaultCellStyle: getCellStyle("center"),
    // },
  };
};

export class DFRatioService {
  static async GetList(data, user) {
    return (await PostJson("/api/df-ratio/getlist", { data, user })) ?? null;
  }

  static async GetItem(data, user) {
    let result = await PostJson("/api/df-ratio/getitem", {
      data,
      user,
    });
    return result ?? null;
  }

  static async SaveItem(data, user) {
    return (await PostJson("/api/df-ratio/update", { data, user })) ?? null;
  }

  static async DeleteItem(data, user) {
    return (
      (await PostJson("/api/df-ratio/delete", {
        data,
        user,
      })) ?? null
    );
  }
}

export class DFSourcePriceService {
  static async GetList(data, user) {
    return (
      (await PostJson("/api/df-source-price/getlist", { data, user })) ?? null
    );
  }
}

export class DFCalcMethodService {
  static async GetList(data, user) {
    return (
      (await PostJson("/api/df-calcmethod/getlist", { data, user })) ?? null
    );
  }

  static async GetItem(data, user) {
    let result = await PostJson("/api/df-calcmethod/getitem", {
      data,
      user,
    });
    return result ?? null;
  }
}

export const SearchDFRatio = (props) => {
  const [setSearchB, data, setData, userInfo, item] = props;

  //** ชื่อฟิลด์ data สำหรับรับข้อมูล */
  const idFieldName = "df_ratio_id";
  const displayFieldName = "ratio_name";

  setSearchB({
    size: "lg",
    show: true,
    fieldId: idFieldName,
    fieldName: "ratio_name",
    sql: {
      fields: [
        "df_ratio_id",
        "ratio_code",
        "ratio_name",
        "src_price_name",
        "calc_method_name",
        "calc_value",
      ],
      tableName:
        " df_ratio a  " +
        " inner join df_source_price b on a.src_price_id = b.src_price_id and b.del_flag='n'  " +
        " inner join df_calculation_method c on a.calc_method_id = c.calc_method_id  and c.del_flag='n'  ",
      defaultCriteria: " a.del_flag ='n' ",
      criteriaFields: ["a.ratio_code", "a.ratio_name"],
      criteriaText: "",
      orderBy: ["a.df_ratio_id"],
      maxRows: 3000,
    },
    /** เมื่อคลิกเลือกรายการ */
    action: (result) => {
      setData((pv) => ({
        ...pv,
        ...DeepMergeObject(
          DotStringToObject(
            item.fieldName + "." + item.searchValueName,
            result[idFieldName]
          ),
          DotStringToObject(
            item.fieldName + "." + item.searchDisplayName,
            result[displayFieldName]
          )
        ),
      }));
      setSearchB((pv) => ({ ...pv, show: false }));
    },
    columns: [
      {
        dataField: "ratio_code",
        text: "รหัส",
        sort: true,
        headerStyle: GetHeaderStyle("120px"),
        style: () => GetNormalStyle("center"),
        filter: textFilter({ placeholder: "..." }),
      },
      {
        dataField: "ratio_name",
        text: "ชื่ออัตรา",
        sort: true,
        headerStyle: GetHeaderStyle("auto", "left"),
        style: () => GetNormalStyle("left"),
        filter: textFilter({ placeholder: "..." }),
      },
      {
        dataField: "src_price_name",
        text: "คิดจาก",
        sort: true,
        headerStyle: GetHeaderStyle("auto"),
        style: () => GetNormalStyle("center"),
        filter: textFilter({ placeholder: "..." }),
      },
      {
        dataField: "calc_method_name",
        text: "วิธีคำนวณ",
        sort: true,
        headerStyle: GetHeaderStyle("auto"),
        style: () => GetNormalStyle("center"),
        filter: textFilter({ placeholder: "..." }),
      },
      {
        dataField: "calc_value",
        text: "ค่าคำนวณ",
        sort: true,
        headerStyle: GetHeaderStyle("80px"),
        style: () => GetNormalStyle("right"),
        filter: textFilter({ placeholder: "..." }),
      },
    ],
  });
};

export class DFService {
  static async BranchApproveFees(data, user) {
    return (
      (await PostJson("/api/df-service/df-branch-accept", { data, user })) ??
      null
    );
  }

  static async RadApproveFees(data, user) {
    return (
      (await PostJson("/api/df-service/df-rad-accept", { data, user })) ?? null
    );
  }

  static async ApproveFees(data, user) {
    return (
      (await PostJson("/api/df-service/df-approval-fees", { data, user })) ??
      null
    );
  }

  static async ReCalculateDF(data, user) {
    return (
      (await PostJson("/api/df-service/recalculate-df", { data, user })) ?? null
    );
  }
}

export class RadiSchedulerService {
  static async Update(data, user) {
    return (
      (await PostJson("/api/radi-scheduler/update", { data, user })) ?? null
    );
  }
  static async GetDateItems(data, user) {
    return (
      (await PostJson("/api/radi-scheduler/get-date-items", { data, user })) ??
      null
    );
  }
  static async GetList(data, user) {
    return (
      (await PostJson("/api/radi-scheduler/getlist", { data, user })) ?? null
    );
  }
}
